import { useCallback, useEffect, useState } from "react";
import { notificationsClient } from "../Pages/Notifications/notificationsClient";
import { useRealtimeEvent } from "./RealtimeProvider";
import { TICKETS_TOPIC, useNotificationsChangedListener } from "./useNotifications";

/**
 * Pastille rouge « Tickets (N) » de la barre latérale : N = le nombre de tickets portant au moins
 * une notification NON LUE pour l'utilisateur courant (nouveau ticket, réponse). Elle s'éteint donc
 * dès que l'utilisateur OUVRE les tickets concernés : plus jamais de pastille qui reste allumée
 * parce qu'un ticket est simplement « ouvert » : l'état ouvert/fermé vit dans la page Tickets, la
 * pastille ne signale que du NOUVEAU. Rafraîchie par l'événement realtime `notification` (créé/lu/
 * invalidé : livré uniquement à l'utilisateur ciblé) et par le bus local après un marquage lu.
 */
export function useTicketBadge(): number {
	const [count, setCount] = useState(0);

	const refresh = useCallback(() => {
		notificationsClient
			.list(0, 200)
			.then((rows) => {
				const tickets = new Set<string>();
				for (const n of rows) {
					if (n.topic !== TICKETS_TOPIC || n.status !== "unread") continue;
					const m = n.linkPath.match(/[?&]ticket=([^&]+)/);
					tickets.add(m ? m[1] : n.sourceKey);
				}
				setCount(tickets.size);
			})
			.catch(() => {
				/* on garde le dernier compteur connu sur une erreur transitoire */
			});
	}, []);

	useEffect(() => {
		refresh();
	}, [refresh]);

	useRealtimeEvent("notification", () => refresh());
	useNotificationsChangedListener(refresh);

	return count;
}
